import { Component, Input, OnInit} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Bank } from 'src/app/assabil-kernel/models/entities/control-tables/bank';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';

@Component({
    selector: 'bank-lov',
    templateUrl: './bank-lov.component.html',
    styleUrls: ['./bank-lov.component.scss']
})


export class BankLovComponent extends GenericLovComponent {

code         : string; 
name         : string; 

banks: Bank[] = [];

columns = [
    {  prop: 'bankCode', name: 'Code'},
    {  prop: 'name', name: 'Nom'}
]


//----------------------------------------------------------------------
constructor( 
    public dialogRef: MatDialogRef<BankLovComponent>,
    protected controlTablesService  : ControlTablesService) {
        super();
        this.entityName = "bank";

}
//----------------------------------------------------------------------
    

//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlTablesService.getList(this.entityName , request).then(result => {
        this.banks = result;
    })
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------  
  closeModal(bank : Bank){
    this.dialogRef.close(bank);
  }
//----------------------------------------------------------------------
}
